<label class="flex cursor-pointer items-center gap-4 p-0">
    <input
        class="absolute h-0 w-0 cursor-pointer opacity-0"
        type="checkbox"
        [ngModel]="checked"
        (ngModelChange)="onModelChange($event)" />
    <div
        class="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-md border border-lightgrey">
        @if (checked) {
            <div class="h-3 w-3 rounded-sm bg-red"></div>
        }
    </div>
    <ng-content> </ng-content>
</label>
@if (
    formControl.hasError('required') &&
    (formControl.touched || formControl.dirty)
) {
    <p class="text-sm text-red">This field needs to be checked</p>
}
